// extracted by mini-css-extract-plugin
export var text = "_b9-0";